module.exports = __webpack_public_path__ + "static/img/quiz_over.646cfb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/win_lose/quiz_over.png
// module id = BI0o
// module chunks = 1